export default __webpack_public_path__ + "static/media/officeButtons.eb32ae24.jpg";